<template>
  <generic-modal
    size="medium"
    :title="$t('inscription')"
    icon="signature"
    image="/images/icons/student.png"
    v-on:destroy="destroy"
    :on_finished="finished"
    :footer_buttons="footer_buttons"
    :show_image="false"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <div class="fields">
          <div class="five wide field">
            <label for>{{ $t("student") }}</label>
            <div class="ui blue search" ref="student_search" v-show="!student">
              <div class="ui icon input">
                <input
                  class="prompt"
                  type="text"
                  name="student"
                  :placeholder="$t('search student')"
                  ref="student_search_input"
                />
                <i class="search icon"></i>
              </div>
              <div class="results"></div>
            </div>
            <div
              class="ui horizontal cards"
              style="display: inline; margin-left: 0"
              v-if="student"
            >
              <div class="ui large image label">
                <img src="/images/icons/matthew.png" />
                {{ student.name }}
                <i class="delete icon" @click="unset_student"></i>
              </div>
            </div>
          </div>
          <div class="three wide field">
            <label for>{{ $t("period") }}</label>
            <div class="ui period selection dropdown" ref="period_dropdown">
              <input type="hidden" name="period" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu"></div>
            </div>
          </div>
          <div class="four wide field">
            <label for>{{ $t("studying cycle") }}</label>
            <div
              class="ui search selection dropdown"
              ref="studying_cycle_dropdown"
            >
              <input type="hidden" name="studying_cycle" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu"></div>
            </div>
          </div>
          <div class="four wide field">
            <label for>{{ $t("studying time") }}</label>
            <div
              class="ui search selection dropdown"
              ref="studying_time_dropdown"
            >
              <input type="hidden" name="studying_time" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu"></div>
            </div>
          </div>
        </div>
        <div class="fields">
          <div class="ten wide field">
            <label for>{{ $t("career") }}</label>
            <div class="ui search selection dropdown" ref="career_dropdown">
              <input type="hidden" name="career" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu"></div>
            </div>
          </div>
          <div class="six wide field">
            <label for>{{ $t("branch") }}</label>
            <div class="ui search selection dropdown" ref="branch_dropdown">
              <input type="hidden" name="branch" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu"></div>
            </div>
          </div>
        </div>
        <!-- <div class="fields">
          <div class="six column wide field">
            <div class="ui horizontal cards" v-if="student">
              <div class="card">
                <div class="image">
                  <img src="/images/icons/matthew.png" />
                </div>
                <div class="content">
                  <div class="header">{{ student.name }}</div>
                  <div class="meta">                    
                  </div>
                  <div class="description">                    
                  </div>
                  <div
                    class="ui basic mini icon labeled button"
                    @click="edit_student"
                  >
                    <i class="edit orange icon"></i>
                    {{ $t("edit") }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ten column wide  field">
            <div class="three fields"></div>
          </div>
        </div> -->
        <div class="ui message error"></div>
      </div>
      <div class="ui two item top attached tabular menu" ref="tabs">
        <a class="active item" data-tab="account_">
          <i class="money icon"></i> {{ $t("account") }}</a
        >
        <a
          class="item"
          data-tab="courses_"
          v-if="
            inscription_configuration &&
            inscription_configuration.show_pensum_courses
          "
        >
          <i class="book icon"></i> {{ $t("courses") }}</a
        >
      </div>
      <div class="ui bottom attached active tab segment" data-tab="account_">
        <branch-based
          class="ten wide column"
          :branch_based="branch_based"
          :inscription_configuration="inscription_configuration"
          ref="branch_based"
        />
      </div>
      <div
        class="ui bottom attached tab segment"
        data-tab="courses_"
        v-if="
          inscription_configuration &&
          inscription_configuration.show_pensum_courses
        "
      >
        <pensum-courses
          class="six wide column"
          :inscription_configuration="inscription_configuration"
          :career="careers"
          :studying_cycle="studying_cycle"
          :studying_time="studying_time"
          ref="pensum_courses"
        />
      </div>

      <!-- <div class="ui grid">
        <branch-based
          class="ten wide column"
          :branch_based="branch_based"
          :inscription_configuration="inscription_configuration"
        />
        <pensum-courses
          class="six wide column"
          :inscription_configuration="inscription_configuration"
          :career="careers"
          :studying_cycle="studying_cycle"
          :studying_time="studying_time"
          v-if="
            inscription_configuration &&
              inscription_configuration.show_pensum_courses
          "
          ref="pensum_courses"
        />
      </div> -->
    </div>
    <template v-for="(mdl, index) in student_modals">
      <component
        :is="mdl"
        :key="index"
        :student_uuid="student ? student.uuid : ''"
        v-on:succedded="succedded"
      ></component>
    </template>
  </generic-modal>
</template>

<script>
import { local_api, stringify, clone } from "@/utils";
import GenericModal from "@/components/GenericModal";
import StudentModal from "@/modules/student/StudentModal";
import { v4 } from "uuid";
import moment from "moment";
import BranchBased from "./BranchBased.vue";
import PensumCourses from "./PensumCourses.vue";
// import ReceiptModal from "@/modules/student_inscription/receipt_modal/ReceiptModal";

export default {
  name: "InscriptionModal",
  components: {
    "generic-modal": GenericModal,
    BranchBased,
    PensumCourses,
  },
  props: {
    period_uuid: String,
    student_uuid: String,
    student_in: Object,
    inscription_in: Object,
  },
  computed: {
    visibility_condition() {
      if (this.inscription_in && this.inscription_in.uuid) return true;
      return false;
    },
    footer_buttons() {
      return [
        {
          text: this.$t("receipt"),
          icon: "print",
          click: this.print_receipt,
          color: "orange",
          visibility_condition: this.visibility_condition,
        },
      ];
    },
  },
  data() {
    return {
      student: undefined,
      period: undefined,
      branch: undefined,
      careers: "",
      studying_cycle: "",
      studying_time: "",
      configuration: {},
      inscription_configuration: {},
      student_modals: [],
      branch_based: {},
      // receipt_modals: [],
    };
  },
  methods: {
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    finished() {
      window.jQuery(this.$refs.form).form("validate form");
      let isValid = window.jQuery(this.$refs.form).form("is valid");
      let vm = this;
      return new Promise((resolve, reject) => {
        if (isValid) {
          if (!vm.student) reject(vm.$t("student not selected"));
          let rule = {};
          if (vm.inscription_configuration.rule == "branch-based")
            rule = vm.branch_based;

          let preinscribe = [];
          if (vm.inscription_configuration.send_to_assignation)
            preinscribe = vm.$refs.pensum_courses.getCourses();

          local_api(vm, "post", "/student_inscription/do-inscribe", {
            s: vm.student.student_id,
            p: vm.period,
            b: vm.branch,
            c: vm.careers,
            y: vm.studying_cycle,
            t: vm.studying_time,
            r: { rule: vm.inscription_configuration.rule, setup: rule },
            pi: preinscribe,
          })
            .then((response) => {
              vm.$emit("succedded", response);
              if (
                vm.inscription_configuration &&
                vm.inscription_configuration.print_receipt
              ) {
                vm.$emit("print_inscription_receipt", response);
              }
              resolve(response);
            })
            .catch((err) => {
              window.jQuery(this.$refs.form).form("add errors", [err]);
              reject(err);
            });
        } else {
          reject();
        }
      });
    },
    edit_student() {
      this.student_modals.push(StudentModal);
    },
    succedded(student) {
      this.student = student;
    },
    remove_mv(movement, index) {
      if (
        this.branch_based &&
        this.branch_based.movements &&
        this.branch_based.movements.length
      )
        this.branch_based.movements.splice(index, 1);
    },
    // destroy_modals() {
    //   this.receipt_modals = [];
    // },
    print_receipt() {
      this.$emit("print_inscription_receipt", this.inscription_in);
    },
    // get_receipt_template() {
    //   let vm = this;
    //   if (
    //     vm.inscription_configuration &&
    //     vm.inscription_configuration.print_receipt
    //   ) {
    //     let trgtTemplate =
    //       vm.inscription_configuration.receipt_layouts.find(
    //         (l) => l.set_as_default,
    //       ) || vm.inscription_configuration.receipt_layouts.find((l) => l);
    //     return trgtTemplate;
    //   }
    // },
    unset_student() {
      this.student = undefined;
    },
  },
  created() {
    let vm = this;
    if (vm.period_uuid) {
      local_api(vm, "post", "/student_configuration/do-get-period", {
        u: vm.period_uuid,
      })
        .then((period) => {
          vm.period = period;
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    }

    if (vm.student_uuid) {
      local_api(vm, "post", "/student/do-get", {
        u: vm.student_uuid,
      })
        .then((student) => {
          vm.student = student;
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    }

    if (vm.student_in) {
      vm.student = clone(vm.student_in);
    }

    local_api(vm, "post", "/student_configuration/do-get-configuration", {})
      .then((configuration) => {
        vm.configuration = configuration;

        setTimeout(() => {
          window
            .jQuery(vm.$refs.period_dropdown)
            .dropdown("setup menu", {
              values: vm.configuration.std_periods.map((p) => {
                return {
                  name: p.name,
                  value: p.period_id,
                  disabled: !p.is_active,
                };
              }),
            })
            .dropdown({
              onChange(value) {
                vm.period = value;
              },
            });

          let defaultPeriod = vm.configuration.std_periods.find(
            (p) => p.is_active,
          );
          if (defaultPeriod) {
            window
              .jQuery(vm.$refs.period_dropdown)
              .dropdown("set selected", defaultPeriod.period_id);
          }

          window
            .jQuery(vm.$refs.career_dropdown)
            .dropdown("setup menu", {
              values: vm.configuration.std_careers.map((c) => {
                return { name: c.name, value: c.career_id };
              }),
            })
            .dropdown({
              onChange(value) {
                vm.careers = value;
              },
            });

          if (vm.configuration.std_studying_cycles) {
            window
              .jQuery(vm.$refs.studying_cycle_dropdown)
              .dropdown("setup menu", {
                values: vm.configuration.std_studying_cycles.map((c) => {
                  return { name: c.name, value: c.studying_cycle_id };
                }),
              })
              .dropdown({
                onChange(value) {
                  vm.studying_cycle = value;
                },
              });
          }

          if (vm.configuration.std_studying_times) {
            window
              .jQuery(vm.$refs.studying_time_dropdown)
              .dropdown("setup menu", {
                values: vm.configuration.std_studying_times.map((c) => {
                  return { name: c.name, value: c.studying_time_id };
                }),
              })
              .dropdown({
                onChange(value) {
                  vm.studying_time = value;
                },
              });
          }

          window
            .jQuery(vm.$refs.branch_dropdown)
            .dropdown("setup menu", {
              values: vm.configuration.std_branches.map((b) => {
                return { name: b.name, value: b.branch_id };
              }),
            })
            .dropdown({
              onChange(value) {
                vm.branch = value;
                if (vm.inscription_configuration) {
                  if (vm.inscription_configuration.rule == "branch-based") {
                    if (vm.inscription_configuration.branch_based) {
                      let trgtBranch =
                        vm.inscription_configuration.branch_based.branches.find(
                          (b) => b.branch.branch_id == value,
                        );
                      if (trgtBranch) {
                        vm.branch_based = trgtBranch;
                        vm.$refs.branch_based.runScript(1);
                        if (vm.branch_based.movements) {
                          vm.branch_based.movements.map((m) => {
                            let expire_date = "";
                            if (m.movement && m.movement.setup) {
                              let stp = m.movement.setup;
                              if (stp.arrear) {
                                if (stp.arrear.policy == "s") {
                                  // Specific day of month
                                  let day = stp.arrear.specific_day;
                                  let currentDate = new Date();
                                  let currentDay = currentDate.getDate();
                                  if (day < currentDay)
                                    expire_date = new Date(
                                      currentDate.getFullYear(),
                                      currentDate.getMonth() + 1,
                                      day,
                                    );
                                  else
                                    expire_date = new Date(
                                      currentDate.getFullYear(),
                                      currentDate.getMonth(),
                                      day,
                                    );
                                } else if (stp.arrear.policy == "g") {
                                  // Grace days
                                  let currDte = moment();
                                  expire_date = currDte.add(
                                    stp.arrear.grace_days,
                                    "d",
                                  );
                                } else if (stp.arrear.policy == "n") {
                                  // None
                                  expire_date = null;
                                }
                              }
                            }
                            m.expire_date = expire_date;
                            m.uuid = v4();
                            return m;
                          });
                        }
                        setTimeout(() => {
                          window.jQuery(vm.$refs.expire_calendar).calendar({
                            type: "date",
                            onChange(value) {
                              let uuid = window.jQuery(this).data("i");
                              let trgt = vm.branch_based.movements.find(
                                (n) => n.uuid == uuid,
                              );
                              if (trgt) trgt.expire_date = value;
                            },
                          });
                        }, 200);
                      }
                    }
                  }
                }
              },
            });

          /** Search for user to set default branch */
          if (vm.configuration.std_users) {
            let currUser = vm.$session.get("user");
            let trgtUser = vm.configuration.std_users.find(
              (u) => u.user_id == currUser.user_id,
            );
            if (trgtUser && trgtUser.std_user && trgtUser.std_user.branch_id) {
              window
                .jQuery(vm.$refs.branch_dropdown)
                .dropdown("set selected", trgtUser.std_user.branch_id);
            }
          }
        }, 200);
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });

    local_api(vm, "post", "/student_inscription/do-get-configuration", {})
      .then((configuration) => {
        if (configuration && configuration.setup) {
          vm.inscription_configuration = JSON.parse(configuration.setup);

          setTimeout(() => {
            window.jQuery(vm.$refs.tabs).find(".item").tab();
          }, 500);
        }
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });
  },
  mounted() {
    let vm = this;

    window.jQuery(this.$refs.form).form({
      fields: {
        student: ["empty"],
        period: ["empty"],
        branch: ["empty"],
        career: ["empty"],
        studying_cycle: ["empty"],
        studying_time: ["empty"],
      },
    });

    window.jQuery(this.$refs.student_search).search({
      apiSettings: {
        action: "search student",
        beforeXHR: function (xhr) {
          let token = vm.$session.get("token");
          if (token) {
            xhr.setRequestHeader("x-access-token", token);
          }

          return xhr;
        },
        onResponse: function (response) {
          if (!response.success) vm.$alertify.error(stringify(response.error));
          else {
            var _response = {
              results: [],
            };
            response.data.map((r) => {
              _response.results.push({
                title: r.name,
                description: r.username,
                student: r,
              });
            });
            _response.results.push({
              title: vm.$t("new"),
              description: vm.$t("new student"),
              student: "NEW",
            });
            return _response;
          }
        },
      },
      onSelect(result) {
        if (result.student == "NEW") {
          vm.student_modals.push(StudentModal);
        } else {
          local_api(vm, "post", "/student/do-get", {
            u: result.student.uuid,
          })
            .then((response) => {
              vm.student = response;
            })
            .catch((err) => {
              vm.$alertify.error(stringify(err));
            })
            .finally(() => {
              vm.processing = false;
            });
        }
      },
    });

    if (vm.student_in) {
      window.jQuery(vm.$refs.student_search_input).val(vm.student_in.name);
    }
  },
  watch: {
    student() {
      let vm = this;
      if (
        vm.student &&
        vm.inscription_configuration &&
        vm.inscription_configuration.run_on_student_selected
      ) {
        // console.log(vm.inscription_configuration.script_student_selected);
        // eslint-disable-next-line no-unused-vars
        var student_id = vm.student.uuid;
        // eslint-disable-next-line no-unused-vars
        var locapi = local_api;
        eval(vm.inscription_configuration.script_student_selected);
      }
      //** Check if is new or old student to apply discount on inscription*/
      // let vm = this;
      // local_api(vm, "post", "/student_inscription/do-verify-student", {
      //   u: vm.student.student_id,
      // })
      //   .then((response) => {
      //     if (!response) {
      //       console.log("aqui debe hacer el descuentón");
      //     }
      //   })
      //   .catch((err) => {
      //     vm.$alertify.error(stringify(err));
      //   })
      //   .finally(() => {
      //     vm.processing = false;
      //   });
    },
  },
};
</script>
